export function ack(prop, { useTimestamp = false } = {}) {
  fetch("/ack", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ prop, use_timestamp: useTimestamp }),
  });
}
